import { ReactComponent as GithubIcon } from "./icons/github.svg";
import { ReactComponent as FacebookIcon } from "./icons/facebook.svg";
import { ReactComponent as LinkedInIcon } from "./icons/linkedIn.svg";
import { ReactComponent as InstagramIcon } from "./icons/instagram.svg";
import { styleIcon } from "./styled";

export const socials = [
    {
        title: "GitHub",
        url: "https://github.com/dondeptu",
        Icon: styleIcon(GithubIcon),
    },
    {
        title: "Facebook",
        url: "https://www.facebook.com/donata.deptula/",
        Icon: styleIcon(FacebookIcon),
    },
    {
        title: "LinkedIn",
        url: "www.linkedin.com/in/dondeptu  ",
        Icon: styleIcon(LinkedInIcon),
    },
    {
        title: "Instagram",
        url: "https://instagram.com/trocheslonca_/",
        Icon: styleIcon(InstagramIcon),
    },
];